import React                   from 'react';
import { withRouter }          from 'react-router';
import { connect }             from 'react-redux';
import { Link }                from "react-router-dom";
import { FormControl }         from 'react-bootstrap';
import { Alert }               from 'react-bootstrap';
import { Badge }               from 'react-bootstrap';
import { ClipLoader }          from 'react-spinners';
import { AwsConstants }        from '../../../utils/environment';
import CatalogBreadcrumb       from './Breadcrumb';
import { categoriesFetchData } from '../../../actions/catalog/categories';

var apiHost = AwsConstants.WebApiHost;

class Catalog extends React.Component {
    
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: ''
    };
    
    this.handleChange   = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    this.props.fetchData(apiHost);
  }
  
  handleChange(e) {
    this.setState({ value: e.target.value });
  }
  
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      window.location = this.state.value ? '/#/search/' + this.state.value : '/#/catalog';
    }
  }

  render() {
    return (
      <div>
        <CatalogBreadcrumb {...this.props} />
	      <label className={'input-group'}>Search across all services
        <div className={'input-group'}>
          <FormControl  
            className={'width100'}
            type="text" 
            value={this.state.value} 
            //placeholder="Search for service" 
            onChange={this.handleChange} 
            onKeyPress={this.handleKeyPress}
          />
          <span className='input-group-btn'>
            <Link className="c-btn c-btn--sm" style={{padding: '4px 42px 1px 14px'}} to={this.state.value ? '/search/' + this.state.value : '/catalog'}>
              <span className="c-btn__text">Search</span>
            </Link>
          </span>
        </div></label>
        
        {this.props.categories.length > 0 ?
          <Alert>
            <h1>Categories <Badge>{this.props.categories.length}</Badge></h1>
          </Alert>
          :
          <div style={{ marginTop: '10px', marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
            <ClipLoader
              color={'#072659'} 
              loading={this.props.isLoading} 
            />
          </div>
        }
        {this.props.categories.length > 0 ?
          <div className="s-content" style={{marginBottom: '20px'}}>
            <div className="g-row g-row--col-2 g-row--col-2--min-full" data-depth="0" data-name="cards" data-livetext="">
              {this.props.categories.map((category, index) => (         
                <div key={index} className="g-col">
                 <div className="c-card c-card--orange c-card--bdr">
                    <a href={"/#"+category.path} className="c-card__link-wrap" aria-label={category.name}><span style={{ display: 'none'}}>{category.name}</span></a>
                    <i className="c-card__icon c-card__icon--arrow c-card__icon--arrow--orange"></i>
                    <div className="c-card__content">
                       <h3 className="c-card__title">
                          {category.name}
                       </h3>
                       {category.description}
                    </div>
                 </div>
              </div>
              ))}
            </div>
          </div>
          :
          <span></span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    categories: state.catalog.categories.categories,
    hasErrored: state.catalog.categories.categoriesHasErrored,
    isLoading: state.catalog.categories.categoriesIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host) => dispatch(categoriesFetchData(host))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Catalog));
